/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const LockIcon: React.SFC = () => {
    return (
        <svg width="33" height="41" viewBox="0 0 33 41" xmlns="http://www.w3.org/2000/svg">
            <g strokeWidth="2" stroke="#555A77" fill="none" fillRule="evenodd">
                <path d="M2 16c-.552 0-1 .448-1 1v22c0 .552.448 1 1 1h29c.552 0 1-.448 1-1V17c0-.552-.448-1-1-1H2zM6 16h21v-6c0-4.97-4.03-9-9-9h-3c-4.97 0-9 4.03-9 9v6z" />
                <path d="M14.133 33h4.734l-.81-6.49.304-.34c.41-.456.64-1.044.64-1.67 0-1.38-1.12-2.5-2.5-2.5S14 23.12 14 24.5c0 .626.23 1.214.64 1.67l.304.34-.81 6.49z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Lock/Lock.tsx